import { PUBLIC_HOLIDAY_YEARS } from "@classroom/domain";
import { useTranslation } from "./i18n";
import "./public-holidays.css";

export default function PublicHolidayNotice({ years = [] }: { years?: number[] }) {
  const { t } = useTranslation("publicHolidays");
  const missing = [...new Set(years)].filter((year) => !PUBLIC_HOLIDAY_YEARS.some((known) => known === year));
  if (missing.length === 0) return null;
  return (
    <aside className="public-holiday-notice" aria-label={t("title")}>
      <p role="status">{t("unavailable", { years: missing.join("、") })}</p>
    </aside>
  );
}
